import liveOpsGuide from "./Guides/liveOpsGuide";
import GuideRenderer from "../../components/wikiComponents/GuideRenderer";

const LiveOpsGuide = () => {
  return <GuideRenderer url="events" guideData={liveOpsGuide} />;
};

export default LiveOpsGuide;
